import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Statement from "../components/Statement";
import { NotesPanel } from "../components/Notes";
import { ChangeLog } from "../components/Extras";
import { MessageManager } from "../components/Messages";

export default function AgentDetail() {
  const { id } = useParams();
  return (
    <div>
      <Link to="/admin/agents" className="inline-flex items-center gap-2 text-xs text-slate-500 hover:text-slate-200 mb-4" data-testid="back-to-agents"><ArrowLeft size={14} />All agents</Link>
      <Statement agentId={id} eyebrow="Agent statement" />
      <NotesPanel targetType="agent" targetId={id} className="mt-6" />
      <ChangeLog agentId={id} />
      <MessageManager agentId={id} title="Portal messages for this agent" />
    </div>
  );
}
